// src/components/CustomCheckbox.js
import React, { useState } from "react";

const CustomCheckbox = ({ label }) => {
  const [checked, setChecked] = useState(false);

  const toggleCheckbox = () => {
    setChecked(!checked);
  };

  return (
    <div className="flex items-center space-x-3">
      <div
        className={`sm:w-[36px] sm:h-[36px] w-[26px] h-[26px] flex items-center justify-center border-[1px] border-black rounded-md cursor-pointer
          ${checked ? "bg-[#7ABF5B] border-[#7ABF5B]" : "bg-[#D9D9D9]"}`}
        onClick={toggleCheckbox}
      >
        {checked && (
          <svg
            className="md:w-7 md:h-7 sm:w-6 sm:h-6 w-4 h-4 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        )}
      </div>
      {label && <label className="text-gray-700">{label}</label>}
    </div>
  );
};

export default CustomCheckbox;
